import * as Yup from "yup";
import {
  repositoryFileMimeTypes,
  repositoryVideoMimeTypes,
  quizImportFileMimeTypes,
  maxFileSize
} from "../constants";
import * as mime from "react-native-mime-types";
import { isValidDate, isBeforeDate, isAfterDay } from "./datetime";

export function validateVideoUrl(url) {
  if (url !== undefined || url !== "") {
    var youtubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|v=|\?v=)([^#]*).*/;
    var vimeoRegExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    var youtubeMatch = url.match(youtubeRegExp);
    var vimeoMatch = url.match(vimeoRegExp);
    var youtubeVideoId = youtubeMatch ? youtubeMatch[2] : undefined;
    var vimeoVideoId = vimeoMatch ? vimeoMatch[5] : undefined;
    var youtubeVideoIdLength = 11;
    if (youtubeMatch && youtubeVideoId.length === youtubeVideoIdLength) {
      return {
        url: "https://www.youtube.com/embed/" + youtubeVideoId + "?autoplay=0",
        type: "url"
      };
    } else if (vimeoMatch) {
      return {
        url: "https://player.vimeo.com/video/" + vimeoVideoId,
        type: "url"
      };
    } else {
      return { url: url, type: "video" };
    }
  }
}

export function validateUrl(url, https) {
  const protocol = https ? "(?:https|https)" : "(?:https?|ftp)";
  /* eslint-disable-next-line */
  const regStr = `^(?:${protocol}:\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$`;
  const regexp = new RegExp(regStr);
  if (regexp.test(url)) {
    return true;
  } else {
    return false;
  }
}

export function validateContentViewerUrl(url) {
  if (url && url !== "") {
    // \& and \? below cause the linter to complain but I don't believe it.
    // eslint-disable-next-line no-useless-escape
    var youtubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
    var vimeoRegExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    var youtubeMatch = url.match(youtubeRegExp);
    var vimeoMatch = url.match(vimeoRegExp);
    if (youtubeMatch && youtubeMatch[2].length === 11) {
      return "https://www.youtube.com/embed/" + youtubeMatch[2] + "?autoplay=0";
    } else if (vimeoMatch) {
      return "https://player.vimeo.com/video/" + vimeoMatch[5];
    } else if (url.match(/virtual_classrooms\/(webinars|meetings)/)) {
      return (
        url +
        "?user_id=" +
        window.currentUser.id +
        "&auth_token=" +
        window.currentUser.authToken
      );
    } else {
      return url;
    }
  }
}

export function validateHttpsUrl(url) {
  // Copyright (c) 2010-2018 Diego Perini (http://www.iport.it)
  return new RegExp(
    /^(?:(?:(?:https):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
  ).test(url);
}

export function validateEmail(email) {
  // eslint-disable-next-line
  let emailRegExp = /^([\w'+\-.'])*[^.]@[a-z\d\-]+(\.[a-z]+)*\.[a-z]{2,}/i;
  return emailRegExp.test(email);
}

export const startDateValidation = (t, required) => {
  let validator = Yup.mixed();
  if (required) {
    validator = validator.required(t("validationMessages.fieldRequired"));
  }
  validator = validator
    .test("validStartDate", t("validationMessages.validDate"), function() {
      return (
        isValidDate(this.parent.startDate) &&
        !isBeforeDate(this.parent.startDate, "01/01/1900")
      );
    })
    .test(
      "startDate",
      t("validationMessages.startDateAfterEndDate"),
      function() {
        const { startDate, endDate } = this.parent;
        return !startDate || !endDate || !isAfterDay(startDate, endDate);
      }
    );
  return validator;
};

export const phoneNumberValidation = (t, required) => {
  let validator = Yup.string();
  if (required) {
    validator = validator.required(t("validationMessages.fieldRequired"));
  }
  validator = validator
    .nullable(true)
    .max(
      25,
      t("validationMessages.cannotExceedLength", {
        type: "Phone",
        maxLength: 25
      })
    )
    .test(
      "phone",
      t("validationMessages.validPhoneNumber", { minLength: 10 }),
      function() {
        return validatePhoneNumber(this.parent.phone);
      }
    );
  return validator;
};

export const fileUploadValidation = (t, required, consistent) => {
  let validator = Yup.mixed();
  if (required) {
    validator = validator.required(t("validationMessages.fileRequired"));
  }
  validator = validator.test(
    "repositoryFileType",
    t("validationMessages.repositoryFileType"),
    file =>
      file === null ||
      (file.type && repositoryFileMimeTypes.indexOf(file.type) >= 0) ||
      (!file.type &&
        repositoryFileMimeTypes.indexOf(mime.lookup(file.name)) >= 0)
  );
  validator = validator.test(
    "videoFileLimit",
    t("validationMessages.videoFileSizeLimit"),
    file =>
      file === null ||
      (file.type && repositoryVideoMimeTypes.indexOf(file.type) < 0) ||
      (!file.type &&
        repositoryVideoMimeTypes.indexOf(mime.lookup(file.name)) < 0) ||
      file.size <= maxFileSize
  );

  if (!!consistent) {
    validator = validator.test(
      "preserveItemFileType",
      t("validationMessages.preserveItemFileType"),
      file => {
        const mimeArray =
          consistent === "video"
            ? repositoryVideoMimeTypes
            : repositoryFileMimeTypes;
        return (
          file === null ||
          (file.type && mimeArray.indexOf(file.type) >= 0) ||
          (!file.type && mimeArray.indexOf(mime.lookup(file.name)) >= 0)
        );
      }
    );
  }
  return validator;
};

export const quizImportFileFormatValidation = file => {
  return !!file && file.type && quizImportFileMimeTypes.indexOf(file.type) >= 0;
};

export const validatePhoneNumber = phoneNumber => {
  return (
    /^(\+?[1-3]{1,3}?[-. ])*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
      phoneNumber
    ) || !phoneNumber
  );
};

export const validateZipCode = zipCode => {
  return /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipCode) || !zipCode;
};
